import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TopBar } from '@/components/TopBar';
import { Page } from '@/components/Page';
import { Button } from '@/components/ui/button';
import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { money, fmtDate } from '@/lib/helpers';
import { Plus, ChevronRight } from 'lucide-react';

export default function Purchases() {
  const navigate = useNavigate();
  const { data: purchases = [] } = useQuery({ queryKey: ['purchases'], queryFn: async () => (await api.get('/purchases')).data.data });
  const badge = { PAID: 'bg-emerald-50 text-emerald-800', PARTIAL: 'bg-amber-50 text-amber-800', UNPAID: 'bg-rose-50 text-rose-700' };
  return (
    <Page>
      <TopBar title="Purchases" showStore={false} right={<Button size="sm" className="h-9 rounded-full" onClick={() => navigate('/purchase')} data-testid="purchases-new"><Plus className="h-4 w-4" /></Button>} />
      <div className="px-4 pt-4 space-y-2">
        {purchases.length === 0 ? <p className="py-10 text-center text-sm text-muted-foreground">No purchases yet.</p> :
          purchases.map((p) => (
            <button key={p.id} onClick={() => navigate(`/purchases/${p.id}`)} className="flex w-full items-center justify-between rounded-xl border border-border bg-card p-3 text-left active:scale-[0.99] transition-transform" data-testid={`purchase-${p.purchase_no}`}>
              <div><p className="font-mono text-sm font-semibold">{p.purchase_no}</p><p className="text-xs text-muted-foreground">{p.supplier_name} · {p.supplier_invoice || '—'}</p><p className="text-xs text-muted-foreground">{fmtDate(p.created_at)} · {p.garment_count} garments</p></div>
              <div className="flex items-center gap-1">
                <div className="text-right"><p className="font-mono text-sm font-semibold">{money(p.amount)}</p><span className={`inline-block rounded-full px-2 py-0.5 text-[10px] font-medium ${badge[p.payment_status]}`}>{p.payment_status}</span>{p.outstanding > 0 && <p className="text-xs text-rose-700">Due {money(p.outstanding)}</p>}</div>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
              </div>
            </button>
          ))}
      </div>
    </Page>
  );
}
